module.exports = __webpack_public_path__ + "img/mv.581d3548.svg";